import { router as webRouter } from '@sm/max-router'

export const router = webRouter

export const subRouter: any = {

}

// 解决方式：给页面加上一个内容为空的iframe，随后立即删除这个iframe，这时候会刷新title。
const setDocumentTitle = function (title) {
  const _body = document.getElementsByTagName("body")[0]
  document.title = title
  const _iframe = document.createElement("iframe")
  _iframe.src = "/favicon.ico"
  _iframe.style.display = "none"

  _iframe.onload = function () {
    setTimeout(function () {
      _iframe.remove()
    }, 0)
  }
  document.body.appendChild(_iframe)
}


export namespace navigation {
  export function getParams() {
    const params = router.getParams()
    return params
  }

  export function getCurrent() {
    return router.getCurrent()
  }

  export function isSubScreen() {
    return false
  }

  export function setNavigationBarTitle(title: string) {
    const u = navigator.userAgent
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    const ua = navigator.userAgent.toLowerCase()
    if ((ua.match(/dingtalk/)) !== null) {
      // 钉钉内打开
      // @ts-ignore
      dd.biz.navigation.setTitle({
        title,
        onSuccess: (result) => { },
        onFail: (err) => { },
      })
    } else if (isiOS) {
      setDocumentTitle(title)
    }
    window.document.title = title
  }
}

export namespace browser {
  export function open(url: string) {
    window.open(url)
  }
}
